import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './guards/auth.guard';
import { VideoSbnCloudPageModule } from './pages/cameras/video-sbn-cloud/video-sbn-cloud.module';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'splash-screen',
    pathMatch: 'full'
  },
  {
    path: 'splash-screen',
    loadChildren: () => import('./pages/splash-screen/splash-screen.module').then( m => m.SplashScreenPageModule)
  },
  {
    path: 'loading-screen',
    loadChildren: () => import('./pages/loading-screen/loading-screen.module').then( m => m.LoadingScreenPageModule)
  },
  {
    
    path: 'login',
    children: [
      {
        path: '',
        loadChildren: () => import('./pages/login/login.module').then( m => m.LoginPageModule)
      }
    ]
  },
  {
    path: 'recuperarpassword',
    loadChildren: () => import('./pages/reset-password/reset-password.module').then( m => m.ResetPasswordPageModule)
  },
  {
    path: 'home',
    loadChildren: () => import('./pages/home/home.module').then( m => m.HomePageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'profile',
    loadChildren: () => import('./pages/profile/profile.module').then( m => m.ProfilePageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'alarm',
    loadChildren: () => import('./pages/alarm/alarm.module').then( m => m.AlarmPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'geo-around',
    loadChildren: () => import('./pages/geo-around/geo-around.module').then( m => m.GeoAroundPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'cyber-safeguard',
    children: [
      {
        path: '',
        loadChildren: () => import('./pages/cyber-safeguard/cyber-safeguard.module').then( m => m.CyberSafeguardPageModule)
      },
      {
        path: 'countdown',
        loadChildren: () => import('./pages/cyber-safeguard/countdown/countdown.module').then( m => m.CountdownPageModule)
      }
    ],
    canActivate: [AuthGuard]
  },
  {
    path: 'cameras',
    children: [
      {
        path: '',
        loadChildren: () => import('./pages/cameras/cameras.module').then( m => m.CamerasPageModule)
      },
      {
        path: 'video-sbn-cloud',
        loadChildren: () => import('./pages/cameras/video-sbn-cloud/video-sbn-cloud.module').then( m => m.VideoSbnCloudPageModule)
      },
      {
        path: 'recordings',
        loadChildren: () => import('./pages/cameras/recordings/recordings.module').then( m => m.RecordingsPageModule),
      },
    ],
    canActivate: [AuthGuard]
  },
  {
    path: 'alarm-panel',
    loadChildren: () => import('./pages/alarm-panel/alarm-panel.module').then( m => m.AlarmPanelPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'register',
    children: [
      {
        path: '',
        loadChildren: () => import('./pages/register/register.module').then( m => m.RegisterPageModule)
      },
      {
        path: 'register-account',
        loadChildren: () => import('./pages/register/register-account/register-account.module').then( m => m.RegisterAccountPageModule)
      },
      {
        path: 'validate-account',
        loadChildren: () => import('./pages/register/validate-account/validate-account.module').then( m => m.ValidateAccountPageModule)
      }
    ]
  },
  {
    path: 'app',
    children: [
      {
        path: 'recuperarpassword',
        loadChildren: () => import('./pages/reset-password/reset-password.module').then( m => m.ResetPasswordPageModule)
      },
      {
        path: 'crearusuario',
        loadChildren: () => import('./pages/register/register.module').then( m => m.RegisterPageModule)
      }
    ]
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules, relativeLinkResolution: 'legacy' })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
